"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MenuItem", {
  enumerable: true,
  get: function get() {
    return _List.ListItem;
  }
});
exports.default = exports.Menu = exports.MenuAnchor = void 0;

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _menu = require("@material/menu");

var _bindDecorator = require("bind-decorator");

var _preact = require("preact");

var _MaterialComponent3 = _interopRequireDefault(require("../Base/MaterialComponent"));

var _List = require("../List");

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof2.default)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var MenuAnchor =
/*#__PURE__*/
function (_MaterialComponent) {
  (0, _inherits2.default)(MenuAnchor, _MaterialComponent);

  function MenuAnchor() {
    var _this;

    (0, _classCallCheck2.default)(this, MenuAnchor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MenuAnchor).apply(this, arguments));
    _this.componentName = 'menu-surface--anchor';
    _this.mdcProps = [];
    return _this;
  }

  (0, _createClass2.default)(MenuAnchor, [{
    key: "materialDom",
    value: function materialDom(props) {
      return (0, _preact.h)("div", Object.assign({}, props), this.props.children);
    }
  }]);
  return MenuAnchor;
}(_MaterialComponent3.default);

exports.MenuAnchor = MenuAnchor;

var Menu =
/*#__PURE__*/
function (_MaterialComponent2) {
  (0, _inherits2.default)(Menu, _MaterialComponent2);

  function Menu() {
    var _this2;

    (0, _classCallCheck2.default)(this, Menu);
    _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Menu).apply(this, arguments));
    _this2.componentName = 'menu';
    _this2.mdcProps = ['open', 'open-from-top-left', 'open-from-top-right', 'open-from-bottom-left', 'open-from-bottom-right'];
    _this2.mdcNotifyProps = ['open'];
    return _this2;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(Menu.prototype), "componentDidMount", this).call(this);

      if (this.control) {
        this.MDComponent = new _menu.MDCMenu(this.control);
        this.MDComponent.listen('MDCMenu:selected', this.onSelect);
        this.MDComponent.listen('MDCMenu:cancel', this.onCancel);
      }

      this.afterComponentDidMount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(Menu.prototype), "componentWillUnmount", this).call(this);

      if (this.MDComponent) {
        this.MDComponent.unlisten('MDCMenu:selected', this.onSelect);
        this.MDComponent.unlisten('MDCMenu:cancel', this.onCancel);
        this.MDComponent.destroy();
      }
    }
  }, {
    key: "onSelect",
    value: function onSelect(e) {
      if (this.props.onSelect) {
        this.props.onSelect(e);
      }

      this.onMenuClosed(e);
    }
  }, {
    key: "onCancel",
    value: function onCancel(e) {
      if (this.props.onCancel) {
        this.props.onCancel(e);
      }

      this.onMenuClosed(e);
    }
  }, {
    key: "onMenuClosed",
    value: function onMenuClosed(e) {
      if (this.props.onMenuClosed) {
        this.props.onMenuClosed(e);
      }
    }
  }, {
    key: "materialDom",
    value: function materialDom(props) {
      return (0, _preact.h)("div", Object.assign({
        class: "mdc-menu-surface",
        tabIndex: "-1"
      }, props, {
        ref: this.setControlRef
      }), (0, _preact.h)(_List.List, {
        className: "mdc-menu__items",
        role: "menu",
        "aria-hidden": "true"
      }, props.children));
    }
  }]);
  return Menu;
}(_MaterialComponent3.default);

exports.Menu = Menu;

__decorate([_bindDecorator.bind], Menu.prototype, "onSelect", null);

__decorate([_bindDecorator.bind], Menu.prototype, "onCancel", null);

__decorate([_bindDecorator.bind], Menu.prototype, "onMenuClosed", null);

var default_1 =
/*#__PURE__*/
function (_Menu) {
  (0, _inherits2.default)(default_1, _Menu);

  function default_1() {
    (0, _classCallCheck2.default)(this, default_1);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(default_1).apply(this, arguments));
  }

  return default_1;
}(Menu);

exports.default = default_1;
default_1.Anchor = MenuAnchor;
default_1.Item = _List.ListItem;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ../node_modules/preact-material-components/Menu/index.js